<template>
  <div v-loading="loading">
    <el-form ref="form" :model="form" label-width="280px" @submit.prevent="onSubmit"
      style="margin: 20px; width: 60%; min-width: 600px">
      <el-form-item label="Mild Weather Day (°F)">
        <el-input v-model="form.mildWeatherDay" @change="valueChanged" type="number"></el-input>
      </el-form-item>
      <el-form-item label="Mild Weather Night (°F)">
        <el-input v-model="form.mildWeatherNight" @change="valueChanged" type="number"></el-input>
      </el-form-item>
      <el-form-item label="Valve Feedback Sensitivity (T5 - %/°F)" style="margin-top: 30px">
        <template #label>
          <label>Feedback Sensitivity (T5 %E<sup>-1</sup> / °F)</label>
        </template>
        <el-input v-model="form.valveFeedbackSensitivity" @change="valueChanged" type="number"></el-input>
      </el-form-item>
      <el-form-item label="Exponential Curve" style="margin-top: 30px">
        <el-input v-model="form.exponentialCurve" @change="valueChanged" type="number"></el-input>
      </el-form-item>
      <el-form-item label="Exponential Sensitivity">
        <el-input v-model="form.exponentialSensitivity" @change="valueChanged" type="number"></el-input>
      </el-form-item>
      <el-form-item label="Integral Period (Minutes)">
        <el-input v-model="form.integralPeriod"></el-input>
      </el-form-item>
      <el-form-item label="Integral Setpoint (°F Loss in Period)">
        <el-input v-model="form.integralSetpoint"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
      </el-form-item>
      <input style="color: white; outline: none; border: none" ref="hidden" />
    </el-form>
    <el-radio-group v-model="dayNightSelector" style="float: right; margin-top: -80px" @change="dayNightSelectorChange">
      <el-radio-button label="Day"></el-radio-button>
      <el-radio-button label="Night"></el-radio-button>
    </el-radio-group>
    <section class="chart-container">
      <el-row>
        <el-col :span="24">
          <div id="chartLine" style="width: 100%; height: 350px; margin-top: -50px"></div>
        </el-col>
      </el-row>
    </section>
  </div>
</template>

<script>
import Axios from "axios"
import echarts from "echarts"
import IOService from "@/api/io.service"
import SettingsService from "@/api/settings.service"
import constants from "@/common/constants/system"

export default {
  data() {
    return {
      loading: false,
      dayNightSelector: "Day",
      chart: {
        Xstart: 80,
        Xstop: 0,
        xAxis: [],
        xAxisPoints: 20
      },
      chartLine: null,
      form: {
        mildWeatherDay: "",
        mildWeatherNight: "",
        valveFeedbackSensitivity: "",
        exponentialCurve: "",
        exponentialSensitivity: "",
        integralPeriod: "",
        integralSetpoint: ""
      },
      editDialog: {
        visible: false,
        value: "",
        title: "",
        currentValue: ""
      },
      linearData: [],
      exponentialData: [],
      user: this.$session.get("User")
    }
  },
  mounted() {
    this.getData()
    for (var i = this.chart.Xstop; i <= this.chart.xAxisPoints; i++) {
      this.chart.xAxis.push((i * (this.chart.Xstart / this.chart.xAxisPoints)).toFixed(0) + "°F")
    }
  },
  methods: {
    verifySettings() {
      if (isNaN(parseInt(this.form.mildWeatherDay)) || parseInt(this.form.mildWeatherDay) < -20 || parseInt(this.form.mildWeatherDay) > 100) {
        const h = this.$createElement
        this.$notify({
          title: "Mild Weather Day",
          message: "Value not valid.  Value should be between -20 and 100",
          type: "error"
        })
        return false
      }
      if (isNaN(parseInt(this.form.mildWeatherNight)) || parseInt(this.form.mildWeatherNight) < -20 || parseInt(this.form.mildWeatherNight) > 100) {
        const h = this.$createElement
        this.$notify({
          title: "Mild Weather Night",
          message: "Value not valid.  Value should be between -20 and 100",
          type: "error"
        })
        return false
      }
      if (isNaN(parseInt(this.form.valveFeedbackSensitivity)) || parseInt(this.form.valveFeedbackSensitivity) < 1 || parseInt(this.form.valveFeedbackSensitivity) > 50) {
        const h = this.$createElement
        this.$notify({
          title: "Valve Feedback Sensitivity",
          message: "Value not valid.  Value should be between 1 and 50",
          type: "error"
        })
        return false
      }
      if (isNaN(parseInt(this.form.exponentialCurve)) || parseInt(this.form.exponentialCurve) < 0 || parseInt(this.form.exponentialCurve) > 100) {
        const h = this.$createElement
        this.$notify({
          title: "Exponential Curve",
          message: "Value not valid.  Value should be between 0 and 50",
          type: "error"
        })
        return false
      }
      if (isNaN(parseInt(this.form.exponentialSensitivity)) || parseInt(this.form.exponentialSensitivity) < 0 || parseInt(this.form.exponentialSensitivity) > 100) {
        const h = this.$createElement
        this.$notify({
          title: "Exponential Sensitivity",
          message: "Value not valid.  Value should be between 0 and 50",
          type: "error"
        })
        return false
      }
      if (isNaN(parseInt(this.form.integralPeriod)) || parseInt(this.form.integralPeriod) < 1 || parseInt(this.form.integralPeriod) > 60) {
        const h = this.$createElement
        this.$notify({
          title: "Integral Period",
          message: "Value not valid.  Value should be between 1 and 60",
          type: "error"
        })
        return false
      }
      if (isNaN(parseInt(this.form.integralSetpoint)) || parseInt(this.form.integralSetpoint) < 0 || parseInt(this.form.integralSetpoint) > 100) {
        const h = this.$createElement
        this.$notify({
          title: "Integral Setpoint",
          message: "Value not valid.  Value should be between 0 and 100",
          type: "error"
        })
        return false
      }
      return true
    },
    saveDataToPanel() {
      if (!this.verifySettings()) return
      this.loading = true
      Axios.all([
        SettingsService.changeSetting(this.user.activeZone, "Settings.Basic.MildWeatherDay", this.form.mildWeatherDay),
        SettingsService.changeSetting(this.user.activeZone, "Settings.Basic.MildWeatherNight", this.form.mildWeatherNight),
        SettingsService.changeSetting(this.user.activeZone, "Settings.Basic.ValveFeedbackSensitivity", this.form.valveFeedbackSensitivity),
        SettingsService.changeSetting(this.user.activeZone, "Settings.Basic.Curve.Exponential", this.form.exponentialCurve),
        SettingsService.changeSetting(this.user.activeZone, "Settings.Basic.Curve.Sensitivity", this.form.exponentialSensitivity),
        SettingsService.changeSetting(this.user.activeZone, "Settings.Basic.Integral.Period", this.form.integralPeriod),
        SettingsService.changeSetting(this.user.activeZone, "Settings.Basic.Integral.Setpoint", this.form.integralSetpoint)
      ])
        .then(
          Axios.spread(
            (
              mildWeatherDayResponse,
              mildWeatherNightResponse,
              valveFeedbackSensitivityResponse,
              exponentialCurveResponse,
              exponentialSensitivityResponse,
              integralPeriodResponse,
              integralSetpointResponse
            ) => {
              //The system should update in 10 seconds.
              this.loading = false
              if (
                mildWeatherDayResponse.data.result != "success" ||
                mildWeatherNightResponse.data.result != "success" ||
                valveFeedbackSensitivityResponse.data.result != "success" ||
                exponentialCurveResponse.data.result != "success" ||
                exponentialSensitivityResponse.data.result != "success" ||
                integralSetpointResponse.data.result != "success" ||
                integralPeriodResponse.data.result != "success"
              ) {
                const h = this.$createElement
                this.$notify({
                  title: "Heat Settings",
                  message: "Error trying to save data to panel",
                  type: "error"
                })
              } else {
                this.$notify({
                  title: "Heat Settings",
                  message: "Settings Saved to Panel",
                  type: "info"
                })
              }
            }
          )
        )
        .catch(() => {
          this.loading = false
          const h = this.$createElement
          this.$notify({
            title: "Heat Settings",
            message: "Error trying to save data to panel",
            type: "error"
          })
        })
    },
    valueChanged() {
      this.generateLinearData()
      this.drawLineChart()
    },
    generateLinearData() {
      this.linearData = []
      this.exponentialData = []
      var peakFound = false
      var previousCorrection = 0
      var peakCorrection = 0
      for (var i = this.chart.Xstop; i <= this.chart.xAxisPoints; i++) {
        var outdoorTemperature = i * (this.chart.Xstart / this.chart.xAxisPoints)
        var subtractor = this.form.mildWeatherDay
        if (this.dayNightSelector == "Night") subtractor = this.form.mildWeatherNight
        var demand = subtractor - outdoorTemperature
        if (demand < 0) demand = 0
        var valveFeedbackSensitivity = this.form.valveFeedbackSensitivity / 10.0
        var linearOutput = valveFeedbackSensitivity * demand
        var exponentialCurve = this.form.exponentialSensitivity
        var exponentialDemand = demand - exponentialCurve
        if (exponentialDemand < 0) exponentialDemand = 0
        var exponentialCorrection = exponentialDemand * exponentialDemand * (this.form.exponentialCurve / 1000)

        var exponentialOutput = (linearOutput - exponentialCorrection).toFixed(1)

        if (linearOutput > 100) linearOutput = 100
        if (exponentialOutput > 100) exponentialOutput = 100
        this.linearData.push(linearOutput.toFixed(1))

        this.exponentialData.push(exponentialOutput)
      }
      //we go throguht the exponentialOutput backwards and make sure its always going up
      exponentialOutput = this.exponentialData[this.exponentialData.length - 1]
      for (let i = this.exponentialData.length - 2; i >= 0; i--) {
        if (parseFloat(this.exponentialData[i]) < parseFloat(exponentialOutput)) {
          this.exponentialData[i] = exponentialOutput
          console.log("f")
        }

        exponentialOutput = this.exponentialData[i]
      }
    },
    dayNightSelectorChange() {
      this.generateLinearData()
      this.drawLineChart()
    },
    onSubmit() {
      console.log("submit!")
    },
    drawLineChart() {
      this.chartLine = echarts.init(document.getElementById("chartLine"))
      this.chartLine.setOption({
        title: {
          text: "Motor estimated output"
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["Linear Control", "Linear & Exponential Combined"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chart.xAxis
        },
        yAxis: {
          type: "value",
          name: "Motor Output (%)"
        },
        series: [
          {
            name: "Linear Control",
            type: "line",
            data: this.linearData
          },
          {
            name: "Linear & Exponential Combined",
            type: "line",
            data: this.exponentialData
          }
        ]
      })
    },
    getData() {
      //Axios.defaults.baseURL = 'http://192.168.137.233:3000';
      Axios.all([IOService.getSettings(this.user.activeZone)]).then(
        Axios.spread((SettingsResponse) => {
          console.log(SettingsResponse.data)
          this.form.mildWeatherDay = SettingsResponse.data.basic.mildWeatherDay
          this.form.mildWeatherNight = SettingsResponse.data.basic.mildWeatherNight
          this.form.valveFeedbackSensitivity = SettingsResponse.data.basic.valveFeedbackSensitivity
          this.form.exponentialCurve = SettingsResponse.data.basic.curve.exponential
          this.form.exponentialSensitivity = SettingsResponse.data.basic.curve.sensitivity
          this.form.integralPeriod = SettingsResponse.data.basic.integral.period
          this.form.integralSetpoint = SettingsResponse.data.basic.integral.setpoint
          this.generateLinearData()
          this.drawLineChart()
        })
      )
    }
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  float: left;
}

/*.chart div {
        height: 400px;
        float: left;
    }*/

.el-col {
  padding: 30px 20px;
}
</style>



// WEBPACK FOOTER //
// Heat.vue?303d8bac